import React from "react";
import {UserAPI} from "../../../api/User/UserAPI";
import {swalError} from "../../../helpers/SweetAlertWrapper";
import ToggleSwitch from "../../../components/BaseComponents/ToggleSwitch/ToggleSwitch";

export class CommentsNotifySection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notifica_risposta_commento: this.props.user.notifica_risposta_commento,
            notifica_like_commento: this.props.user.notifica_like_commento
        }
    }

    onToggle = ({target}) => {
        let settings = {}
        //Inverte lo stato
        settings[target.id] = (this.state[target.id] ? 0 : 1)
        UserAPI.Settings.notificheSettings(settings)
            .then(_ => {
                this.setState(settings)
            })
            .catch(message => swalError(message))
    };

    render() {
        return (
            <div className={"list-group list-group-flush"}>
                {/*RISPOTE*/}
                <div className={"list-group-item list-group-item-action"}>
                    <h5 className={"my-0"}>Risposte ai tuoi commenti</h5>
                    <div className={"row align-items-center"}>
                        <div className={"col-8"}>
                            Notifiche alle risposte
                        </div>
                        <div className={"col-4 text-right"}>
                            <ToggleSwitch id={`notifica_risposta_commento`}
                                          currentValue={!!parseInt(this.state.notifica_risposta_commento)}
                                          onChange={this.onToggle}/>
                        </div>
                    </div>

                    <small>Ricevi una notifica quando c'é stata una risposta ad un tuo commento sotto un post presente
                        nel feed</small>
                </div>

                {/*LIKE*/}
                <div className={"list-group-item list-group-item-action border-bottom"}>
                    <h5 className={"my-0"}>Like ai tuoi commenti</h5>
                    <div className={"row align-items-center"}>
                        <div className={"col-8"}>
                            Notifiche dei like
                        </div>
                        <div className={"col-4 text-right"}>
                            <ToggleSwitch id={`notifica_like_commento`}
                                          currentValue={!!parseInt(this.state.notifica_like_commento)}
                                          onChange={this.onToggle}/>
                        </div>
                    </div>

                    <small>Ricevi una notifica quando un utente ha cliccato il tasto "mi piace" ad un tuo
                        commento</small>
                </div>
            </div>
        )
    }
}

